module.exports = __webpack_public_path__ + "img/ga-grey.66d71027.svg";